export const LANGUAGE_NONE = "none";

export const LANGUAGE_NONE_LABEL = "None";
